import { render, staticRenderFns } from "./OfferReporter.vue?vue&type=template&id=fdd95c66"
import script from "./OfferReporter.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferReporter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OfferReporter.vue?vue&type=style&index=0&id=fdd95c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports